module.exports = __webpack_public_path__ + "static/media/BB.95c11475.svg";